export default "__VITE_ASSET__DvWD3koo__"